import { FC } from 'react'

import { Button, ButtonSizes, ButtonVariants } from '@inno-ui/button'
import { Modal } from '@inno-ui/modal'
import { useTranslation } from 'react-i18next'

import styles from './CachingReloadPromptModal.module.scss'

type CachingReloadPromptModalProps = {
  isOpen: boolean
  onClose: () => void
}

export const CachingReloadPromptModal: FC<CachingReloadPromptModalProps> = ({
  isOpen,
  onClose
}) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'desktop.preferences.caching.reload_prompt'
  })

  const handleReload = () => {
    window.location.reload()
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      zIndex={1010}
      maxWidth={480}
      maxHeight={320}
      isSidebarOpen={false}
      layers={[
        {
          title: t('title'),
          body: (
            <div className={styles.body}>
              <p className={styles.message}>{t('message')}</p>
              <div className={styles.buttons}>
                <Button
                  variant={ButtonVariants.Ghost}
                  size={ButtonSizes.M}
                  onClick={onClose}
                  label={t('later_button')}
                />
                <Button
                  size={ButtonSizes.M}
                  onClick={handleReload}
                  label={t('reload_button')}
                />
              </div>
            </div>
          )
        }
      ]}
    />
  )
}
